var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRiskProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 60,
    viewBox: "0 0 50 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3726",
    "data-name": "Rectangle 3726",
    width: 50,
    height: 60,
    transform: "translate(73 2059)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_579",
    "data-name": "Mask Group 579",
    transform: "translate(-73 -2059)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BPD-icon2-ser-09",
    transform: "translate(73 2061.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M34.737,32.81a26.6,26.6,0,0,0-7.672-1.848L20.9,55.711H39.847A1.388,1.388,0,0,0,41.235,54.4c0-.372.565-9.068.565-11.315,0-4.817-2.382-8.258-7.076-10.286",
    fill: "#3bc1d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M20.97,30.651C7.054,30.651,0,34.846,0,43.1,0,45.338.5,54.043.517,54.4A1.392,1.392,0,0,0,1.9,55.715H20.9l6.17-24.753a56.3,56.3,0,0,0-6.1-.311",
    fill: "#359ebb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M20.909,0c-7.729,0-9.563,6.03-9.743,11.1v5.6c0,5,1.528,7.882,3.63,9.471L21.316,0h-.407",
    fill: "#f18122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M30.651,11.083C30.454,6.13,28.672.223,21.311,0l-6.52,26.172a10.02,10.02,0,0,0,6.13,1.8c4.427,0,9.73-1.953,9.73-11.267V11.083",
    fill: "#f6911e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M34.325,53.881a1.366,1.366,0,0,1-1.366-1.366V49.042a1.366,1.366,0,1,1,2.728,0V52.5a1.366,1.366,0,0,1-1.362,1.366",
    fill: "#e2ded6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M41.117,53.881a1.366,1.366,0,0,1-1.366-1.366V47.558a1.366,1.366,0,1,1,2.732,0v4.957a1.366,1.366,0,0,1-1.366,1.366",
    fill: "#d91a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M47.912,53.881a1.366,1.366,0,0,1-1.366-1.366V43.884a1.366,1.366,0,1,1,2.732,0v8.631a1.366,1.366,0,0,1-1.366,1.366",
    fill: "#00c9db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M33.463,46a1.366,1.366,0,0,1-.779-2.487l4.256-2.938a1.371,1.371,0,0,1,1.239-.162l2.715.976,6.568-4.865a1.366,1.366,0,1,1,1.625,2.189l-7.159,5.307a1.371,1.371,0,0,1-1.274.188l-2.741-.99-3.674,2.54a1.371,1.371,0,0,1-.775.241",
    fill: "#f18122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M48.285,41.673h-.162a1.371,1.371,0,0,1-1.2-1.519l.184-1.533-1.874-.153a1.366,1.366,0,0,1,.223-2.724l3.288.271a1.353,1.353,0,0,1,.941.5,1.314,1.314,0,0,1,.3,1.025l-.346,2.938a1.366,1.366,0,0,1-1.357,1.2",
    fill: "#f18122"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskProfileIcon);
export default __webpack_public_path__ + "static/media/risk-profile-icon.3505b54ecad670ca9f43a2cb09b0b16d.svg";
export { ForwardRef as ReactComponent };